<div class="filtered-idea-list" #divParent>
  <ng-container *ngIf="width">
    <virtual-scroller
      [bufferAmount]="0"
      [ngStyle]="{ height: height, width: width }"
      #scroll
      [items]="ideas">
      <div *ngFor="let idea of scroll.viewPortItems" class="idea-container">
        <app-idea-card
          [idea]="idea"
          [xs]="true"
          [session]="getSessionForIdea(idea)"
          [showTopic]="false"
          (ideaAction)="
            openIdea(idea, getSessionForIdea(idea))
          "></app-idea-card>
      </div>
    </virtual-scroller>
  </ng-container>
</div>
